import React from "react";
import { MINI_DRAWER } from "constants/ActionTypes";

import GeneralApi from "../../app/generalApi";
const generalApi = new GeneralApi();

const SidenavLogo = ({ drawerType }) => {
  return (
    <div className="d-flex align-items-center">
      <div
        style={{
          width: "100%",
          textAlign: "center",
          float: "center",
        }}
      >
        <img
          style={{ maxWidth: "80%" }}
          src={generalApi.getImage("logo_header.png")}
        />
      </div>
    </div>
  );
};

export default SidenavLogo;



// WEBPACK FOOTER //
// ./components/SidenavLogo/index.js